import {colorNames, useNamedColor} from '@github-ui/use-named-color'

import styles from './IssueTypePickerItemLeadingVisual.module.css'

export type IssueTypeColor =
  | 'BLUE'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'PINK'
  | 'PURPLE'
  | 'RED'
  | 'YELLOW'
  // eslint-disable-next-line relay/no-future-added-value
  | '%future added value'

export const createIssueTypePickerItemLeadingVisual = (color: IssueTypeColor) =>
  function IssueTypePickerItemLeadingVisual() {
    const effectiveColor = colorNames.find(c => c === color)
    const {bg, accent} = useNamedColor(effectiveColor)
    return (
      <div
        style={{'--bg': `${bg}`, '--accent': `${accent}`} as React.CSSProperties}
        className={styles.issueTypeColorIndicator}
      />
    )
  }

try{ IssueTypePickerItemLeadingVisual.displayName ||= 'IssueTypePickerItemLeadingVisual' } catch {}